import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoutesCommon, RoutesHelloWorld, SERVICING_ROUTES, TEST_ROUTES } from '@conf';
import { ErrorsHandlerGuard } from '@lib/guards/errors-handler.guard';
import { EMDSearchGuard } from 'src/guards/emd-search.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        redirectTo: `/${RoutesCommon.SYSTEM_ERROR}`,
        pathMatch: 'full',
      },
      // {
      //   path: RoutesHelloWorld.TEST_TO,
      //   loadChildren: () => import('./test-to/container/test-to-cont.module').then((m) => m.TestToContModule),
      // },
      {
        path: `${RoutesCommon.COMMON}/:type`,
        canActivate: [ErrorsHandlerGuard],
        loadChildren: () =>
          import('@lib/components/shared-ui-components/common-error/container/common-error-cont.module').then(
            (m) => m.CommonErrorContModule
          ),
      },
      {
        path: SERVICING_ROUTES.emdSelect,
        loadChildren: () => import('./e-ticket-emd-select').then((m) => m.ETicketEmdSelectContModule),
      },
      {
        path: SERVICING_ROUTES.receiptSelect,
        loadChildren: () => import('./receipt-select').then((m) => m.ReceiptSelectContModule),
      },
      {
        path: SERVICING_ROUTES.receiptSearch,
        loadChildren: () => import('./receipt-search').then((m) => m.ReceiptSearchContModule),
      },
      {
        path: SERVICING_ROUTES.boardingCertificateSearch,
        loadChildren: () => import('./boarding-certificate-search').then((m) => m.BoardingCertificateSearchContModule),
      },
      // ----------------OKI追加start------------------
      {
        path: SERVICING_ROUTES.myBooking,
        loadChildren: () => import('./my-booking/container/my-booking-cont.module').then((m) => m.MyBookingContModule),
      },
      {
        path: SERVICING_ROUTES.bookingList,
        loadChildren: () =>
          import('./booking-list/container/booking-list-cont.module').then((m) => m.BookingListContModule),
      },
      {
        path: SERVICING_ROUTES.bookingSearch,
        loadChildren: () =>
          import('./booking-search/container/booking-search-cont.module').then((m) => m.BookingSearchContModule),
      },
      {
        path: SERVICING_ROUTES.seatMap,
        loadChildren: () => import('./seatmap/container/seatmap-cont.module').then((m) => m.SeatmapContModule),
      },
      {
        path: SERVICING_ROUTES.seatAttributeRequest,
        loadChildren: () =>
          import('./seat-attribute-request/container/seat-attribute-request-cont.module').then(
            (m) => m.SeatAttributeRequestContModule
          ),
      },
      {
        path: SERVICING_ROUTES.informativeSeatmap,
        loadChildren: () =>
          import('./informative-seatmap/container/informative-seatmap-cont.module').then(
            (m) => m.InformativeSeatmapContModule
          ),
      },
      {
        path: SERVICING_ROUTES.juniorPilotInput,
        loadChildren: () =>
          import('./junior-pilot-request/container/junior-pilot-request-cont.module').then(
            (m) => m.JuniorPilotRequestContModule
          ),
      },
      {
        path: '**',
        redirectTo: `/${RoutesCommon.SYSTEM_ERROR}`,
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { urlUpdateStrategy: 'eager', onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
